module.exports = require("live/components/widget/more-options-section");